import { AxiosError } from "axios";

import { errorCodes } from "@api/interceptors/constants";
import { InterceptorErrorHandler } from "@api/interceptors/types";
import { handleLogout } from "@api/interceptors/utils";

export const forbiddenPausePortal: InterceptorErrorHandler = (error: AxiosError) => {
  const { response } = error;

  if (
    response?.status === 403 &&
    response?.data?._errors?.[0]?.id === errorCodes["403"].forbidden.pausePortal
  ) {
    handleLogout();
  }
};
